import React from 'react';

import { IconRightArrow } from '@trqk/components';
import { locale } from '@trqk/utils';

import { CardWrapper } from '../../..';
import welcomeLogoUrl from '../../../../../../../assets/svg/insights-empty-welcome.svg';

const iconContainerHeight = 25;

/**
 * An Insights card that shows a welcome message and intro to Trqk.
 */
export const WelcomeCard = (): JSX.Element => (
    <CardWrapper addClasses="overflow-hidden">
        <div className="relative pb-4" style={{ height: iconContainerHeight }}>
            <img
                src={welcomeLogoUrl}
                alt="Trqk mark logo"
                className="absolute"
                style={{
                    top: -50,
                    left: -50,
                    width: 250,
                }}
            />
        </div>
        <div className="flex flex-col mt-24">
            <h4 className="mt-4 mb-2 text-center">
                {locale.enUS.INSIGHTS.CARDS.WELCOME.TITLE}
            </h4>
            <div className="mx-10">
                <div className="my-4">
                    {locale.enUS.INSIGHTS.CARDS.WELCOME.PART_1}
                </div>
                <div className="mt-4">
                    {locale.enUS.INSIGHTS.CARDS.WELCOME.PART_2}
                </div>
            </div>
            <div className="mx-10 flex-grow flex flex-col items-start mb-8">
                <div className="my-4 font-bold flex">
                    <div className="mr-1">
                        {locale.enUS.INSIGHTS.CARDS.WELCOME.HOW_TO_GET_STARTED}
                    </div>
                    <IconRightArrow fillColor="black" width={20} />
                </div>
            </div>
        </div>
    </CardWrapper>
);
